import styled, { css } from 'styled-components';

const AccordionFAQStyled = styled.section.attrs({
    className: 'accordionFAQ',
})
`${({theme}) => {
  const {media} = theme;
    return css`
    .faq {
      display: flex;
      flex-direction: column;
      padding: 150px 0 0px;
      gap: 50px;

      &__headline{
        text-align: center;
        font-size: 56px;
        line-height: 60px;
        font-weight:700;
        margin-bottom: 25px;
        ${media.tablet.down}{
          font-size: 30px;
          margin-bottom:10px;
        }
        ${media.mobile.down}{
          text-align: left;
       
        }
  
      }

      &__subhead{
        font-size: 30px;
        text-align: center;
        padding-top: 0;
        font-weight:700;
        ${media.tablet.down}{
          font-size: 20px;
        }
        ${media.mobile.down}{
          text-align: left;
          font-size: 16px;
        }
      }
    
  
      &__title {
        font-size: 18px;
        text-align: left;
        font-weight: 700;
        line-height: 22px;
        margin-bottom; 0;
        padding: 1rem 0 1rem;
        justify-self: center;
        ${media.tablet.down}{
          font-size: 16px;
        }
  
        &__expanded {
        flex-direction: horizontal;
        font-size: 18px;
        text-align: left;
        font-weight: 700;
        padding: 1rem 0 1rem;
        ${media.tablet.down}{
          font-size: 16px;
        }
        }
      }
  
      &__content{
        display: none;
  
        &__expanded{
          display: inline-block;
          flex-direction: row;
          align-items: center;
          font-size: 16px;
          text-align: left;
          font-weight: 400;
          line-height: 20px;
          flex-wrap: wrap;
        }
      }

      &__questions-wrapper{
        display: flex;
        flex-direction: column;
      }

      &__phone{
        display: inline-block;        
        padding: 0 .3rem 0;
        font-size: 16px;
      }
  }
    button {
        display: flex;
        align-items: start;
        justify-content: space-between;
        align-content: center;
        width: 100%;
        border: 0;
        border-radius: 0;
        background: 0;
        cursor: pointer;
      }
  
      .angleDown{
        min-width: 16px;
        height: 16px;
        color: inherit;
  
          &__expanded{
          transform: scale( 1, -1) ;
          width: 16px;
          height: 16px;
          color: inherit;
            }
        }

        .question-wrapper{
          border-bottom: 1px solid #CFD5E1;
          display: flex;
          flex-direction: column;
          padding: 1rem 0 1rem;
          &:first-of-type {
             padding-top: 0;
            }
          }
  
    `

}}`

export default AccordionFAQStyled
